import React from "react";
import { Row, Col } from "antd";
import { InputItem } from "../../../components/forms/FormItems";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import { useSelector } from "react-redux";
import ReadOnlyItem from "../../../components/forms/ReadOnlyItem";
import { useIntl } from "react-intl";

const ClientAccountingNumber = () => {
  const activeTemplate = useSelector(
    (state) => state.clientDetails.activeTemplate
  );
  const intl = useIntl();

  return (
    <ChildrenAnimationWrapper>
      <Row>
        <Col span={11}>
          {activeTemplate ? (
            <AnimationChildWrapper itemKey={1}>
              <ReadOnlyItem
                content={activeTemplate.name}
                name="name"
                category="client"
              />
            </AnimationChildWrapper>
          ) : null}
          {activeTemplate &&
          activeTemplate.specific_data &&
          activeTemplate.specific_data.comittee_name ? (
            <AnimationChildWrapper itemKey={1}>
              <ReadOnlyItem
                content={activeTemplate.specific_data.comittee_name}
                name="specific_data.comittee_name"
                category="client"
              />
            </AnimationChildWrapper>
          ) : null}
          <AnimationChildWrapper itemKey={1}>
            <InputItem
              name="accounting_code"
              category="client"
              required={true}
            />
          </AnimationChildWrapper>

          <AnimationChildWrapper itemKey={2}>
            <InputItem name="debit_account_number" category="client" />
          </AnimationChildWrapper>
        </Col>
        <Col span={11} offset={2}>
          {activeTemplate ? (
            <AnimationChildWrapper itemKey={1}>
              <ReadOnlyItem
                content={
                  activeTemplate.social_security
                    ? intl.formatMessage({
                        id: "app.forms.yes",
                      })
                    : intl.formatMessage({
                        id: "app.forms.no",
                      })
                }
                name="specific_data.social_security"
                category="client"
              />
            </AnimationChildWrapper>
          ) : null}
          {activeTemplate &&
          activeTemplate.specific_data &&
          activeTemplate.specific_data.comittee_number ? (
            <AnimationChildWrapper itemKey={1}>
              <ReadOnlyItem
                content={activeTemplate.specific_data.comittee_number}
                name="specific_data.comittee_number"
                category="client"
              />
            </AnimationChildWrapper>
          ) : null}
          <AnimationChildWrapper itemKey={3}>
            <InputItem
              number={true}
              name="business_id"
              category="client"
              min={1}
            />
          </AnimationChildWrapper>
          <AnimationChildWrapper itemKey={4}>
            <InputItem name="credit_account_number" category="client" />
          </AnimationChildWrapper>
        </Col>
      </Row>
    </ChildrenAnimationWrapper>
  );
};

export default ClientAccountingNumber;
